import { css } from "styled-components";

import { rydeColors, ScreenDepth } from "@ryde/theme";

import {
  COURSE_CODE_MARKER_HEIGHT_PX,
  COURSE_CODE_MARKER_WIDTH_PX,
  STATION_PIN_PATH,
} from "./map.const";

export const DRAWER_START_INLINE_GAP = 16;
export const MULTIPLE_DRAWER_OFFSET_WIDTH = 16;

export const innerItemEditStyles: React.CSSProperties = {
  position: "relative",
  zIndex: ScreenDepth.INNER_ITEM_EDIT,
  filter: "none",
  backdropFilter: "none",
};

export const MAP_MARKER_ICON_STYLES = css`
  .map-marker-icon-container {
    width: 100%;
    height: 100%;
  }

  .map-marker-icon-inner {
    width: 100%;
    height: 100%;
    clip-path: path("${STATION_PIN_PATH}");
  }

  .map-marker-icon-text {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    padding-top: 8px;
    font-size: 13px;
    position: relative;
    text-align: center;
    font-weight: 600;
  }

  .map-marker-icon-bg-ava {
    position: absolute;
    top: 50%;
    inset-inline-start: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .map-marker-icon-ava {
    position: absolute;
    top: 50%;
    inset-inline-start: 50%;
    transform: translate(-50%, -80%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .map-marker-icon-badge {
    position: absolute;
    top: -3%;
    inset-inline-end: -24%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 24px;
    height: 24px;
  }

  .map-marker-icon-badge-text {
    font-size: 12px;
    font-weight: bold;
    color: ${rydeColors.white};
  }

  .map-marker-icon-dropOff {
    .map-marker-icon-inner {
      background-color: ${rydeColors.white} !important;
    }
  }

  /* Live map course tracking marker: SVG pin (currentColor = line), white stroke in asset. */
  .map-marker-icon.map-marker-icon--course-code {
    width: ${COURSE_CODE_MARKER_WIDTH_PX}px;
    height: ${COURSE_CODE_MARKER_HEIGHT_PX}px;

    .map-marker-icon-course-pin-wrap {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .map-marker-icon-course-pin-svg {
      display: block;
      width: 100%;
      height: 100%;
    }

    .map-marker-icon-text {
      position: absolute;
      inset-inline: 0;
      top: 3px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 68%;
      padding-top: 0;
      padding-inline: 5px;
      color: ${rydeColors.white} !important;
      font-size: 12px;
      font-weight: 700;
      line-height: 1;
      transform: translateY(2px);
      pointer-events: none;
      text-shadow: 0 1px 2px ${rydeColors.black}66;
    }
  }
`;
